import * as React from 'react';
import { useSelector } from 'react-redux';

import { PageLoader } from '../../components/PageLoader';
import { selectComparisonLoading } from '../../selectors/comparison';

export const PageLoaderContainer: React.VFC = () => {
  const isLoading = useSelector(selectComparisonLoading);

  if (!isLoading) {
    return null;
  }

  return <PageLoader />;
};
